import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// ScrollTriggerを登録
gsap.registerPlugin(ScrollTrigger);

export function fvHeadingAnime() {
  setTimeout(() => {
    // c-text-anime要素を取得
    const textElements = document.querySelectorAll(".c-fv-anime");
    const mainTimeline = gsap.timeline();

    textElements.forEach((textElement, index) => {
      // 元のテキストを取得
      const originalText = textElement.textContent;
      textElement.textContent = ''; // 元のテキストをクリア

      // テキストを包むspanを生成
      const textSpan = document.createElement("span");
      textSpan.classList.add("c-fv-text-anime__text");
      textSpan.textContent = originalText;
      textSpan.style.opacity = "0"; // 初期状態で透明

      // 背景用のspanを生成し、クラスを追加
      const bgSpan = document.createElement("span");
      bgSpan.classList.add("c-fv-text-anime__bg");

      // 親要素に子要素を追加
      textElement.appendChild(textSpan);
      textElement.appendChild(bgSpan);

      // 各要素に対して個別のタイムラインを作成し、メインタイムラインに追加
      const tl = gsap.timeline({
        delay: index * 0.5 // 各アニメーションの開始をずらす
      });

      tl.fromTo(bgSpan, 
          { y: "-100%" }, 
          { y: "0%", duration: 0.3, ease: "power1.out" }
        )
        .to(bgSpan, 
          { y: "0%", duration: 0.3, ease: "none" } // 真ん中で一瞬止まる
        )
        .to(textSpan, 
          { opacity: 1, duration: 0.3, ease: "power1.out" }, "-=0.3" // 背景が止まっている間にテキストを表示
        )
        .to(bgSpan, 
          { y: "100%", duration: 0.5, ease: "power1.out" } // 真ん中から下に流れる
        )
        .add(() => {
          textElement.dataset.animeDone = "true"; // アニメーションが完了したらフラグを設定
        });

      mainTimeline.add(tl, 0); // メインタイムラインに追加
    });

    // c-fv-en-anime要素を取得
    const enTextElements = document.querySelectorAll(".c-fv-en-anime");

    enTextElements.forEach((enTextElement, index) => {
      // 元のテキストを取得
      const originalText = enTextElement.textContent;
      enTextElement.textContent = ''; // 元のテキストをクリア

      // テキストを包むspanを生成
      const enTextSpan = document.createElement("span");
      enTextSpan.classList.add("c-fv-en-anime__text");
      enTextSpan.textContent = originalText;
      enTextSpan.style.opacity = "0"; // 初期状態で透明

      // 背景用のspanを生成し、クラスを追加
      const enBgSpan = document.createElement("span");
      enBgSpan.classList.add("c-fv-en-anime__bg");

      // 親要素に子要素を追加
      enTextElement.appendChild(enTextSpan);
      enTextElement.appendChild(enBgSpan);

      // 各要素に対して個別のタイムラインを作成し、メインタイムラインの後に追加
      const enTl = gsap.timeline({
        delay: index * 0 // 各アニメーションの開始をずらす
      });

      enTl.fromTo(enBgSpan, 
          { x: "-100%" }, 
          { x: "0%", duration: 0.2, ease: "power1.out" }
        )
        .to(enBgSpan, 
          { x: "0%", duration: 0.05, ease: "none" } // 真ん中で一瞬止まる
        )
        .to(enTextSpan, 
          { opacity: 1, duration: 0.05, ease: "power1.out" }, "-=0.05" // 背景が止まっている間にテキストを表示
        )
        .to(enBgSpan, 
          { x: "100%", duration: 0.2, ease: "power1.out" } // 真ん中から右に流れる
        )
        .add(() => {
          enTextElement.dataset.animeDone = "true"; // アニメーションが完了したらフラグを設定
        });

      mainTimeline.add(enTl, `+=${textElements.length * 0}`); // c-fv-animeのアニメーションが完了した後に開始
    });
  }, 500);
}

// 見出しのアニメーション
export function headingAnime() {
  const headings = document.querySelectorAll('.c-heading-anime');
  headings.forEach((heading) => {
    if (heading.dataset.animeDone === "true") return;
    heading.dataset.animeDone = "true";
    // 元のテキストを取得
    const originalText = heading.textContent;
    heading.textContent = ''; // 元のテキストをクリア

    // テキスト用のspanを生成し、クラスを追加
    const textSpan = document.createElement("span");
    textSpan.classList.add("c-heading-anime__text");
    textSpan.textContent = originalText;
    textSpan.style.visibility = "hidden"; // 初期状態で非表示
    textSpan.style.opacity = "0"; // 初期状態で透明

    // 背景用のspanを生成し、クラスを追加
    const bgSpan = document.createElement("span");
    bgSpan.classList.add("c-heading-anime__bg");

    // 親要素に子要素を追加
    heading.appendChild(bgSpan);
    heading.appendChild(textSpan);

    // アニメーションのシーケンスを設定
    gsap.timeline({
      scrollTrigger: {
        trigger: heading,
        start: "top 80%", // トリガーが画面の80%に来たときに開始
        toggleActions: "play none none none", // 一度だけ再生
      }
    })
    .set([bgSpan, textSpan], { opacity: 0 }) // 初期状態で非表示
    .fromTo(bgSpan, 
      { x: "-100%", opacity: 1 }, 
      { x: "100%", duration: 0.05, ease: "power1.out" } // 背景が左から右に流れる
    )
    .add(() => {
      textSpan.style.visibility = "visible";
      textSpan.style.opacity = "1";
    }, "-=0.05") 
    .fromTo(textSpan, 
      { x: "-100%" }, 
      { x: "0%", duration: 0.05, ease: "power1.out" }, // テキストが左から右に流れる
      "-=0.05" // 背景がスライドアウトする途中でテキストをスライド
    );
  });
}

// テキストのアニメーション
export function textAnime() {
  const texts = document.querySelectorAll('.c-text-anime');
  texts.forEach((text) => {
    if (text.dataset.animeDone === "true") return;
    text.dataset.animeDone = "true";
    // 元のテキストを取得
    const originalText = text.textContent;
    text.textContent = ''; // 元のテキストをクリア

    // テキスト用のspanを生成し、クラスを追加
    const textSpan = document.createElement("span");
    textSpan.classList.add("c-text-anime__text");
    textSpan.textContent = originalText;
    textSpan.style.opacity = "0"; // 初期状態で透明

    // 背景用のspanを生成し、クラスを追加
    const bgSpan = document.createElement("span");
    bgSpan.classList.add("c-text-anime__bg");

    // 親要素に子要素を追加
    text.appendChild(bgSpan);
    text.appendChild(textSpan);

    // GSAPのScrollTriggerを使用して、スクロールして画面内に入ったらアニメーションを発火
    gsap.timeline({
      scrollTrigger: {
        trigger: text,
        start: "top 80%", // トリガーが画面の80%に来たときに開始
        toggleActions: "play none none none", 
      }
    })
    .set([bgSpan, textSpan], { opacity: 0 }) // 初期状態で非表示
    .fromTo(bgSpan, 
      { x: "-100%", opacity: 1 }, 
      { x: "100%", duration: 1, ease: "power1.out" } // 背景が左から右に流れる
    )
    .fromTo(textSpan, 
      { opacity: 0 }, 
      { opacity: 1, duration: .5, ease: "power1.out" }
    );
  });
}